// Font roles for plates, codes and numbers. Spread into `sx` or inline `style`:
//   sx={{ ...plateFont, fontWeight: 700 }}
// Pick by what the value IS, never by looks. Rules and background in CLAUDE.md
// ("Fonts for plates, codes and numbers"). The font names must not appear anywhere
// else in frontend/src: ./test.sh tests.test_font_roles_guard enforces that.
// The weights loaded for the two mono fonts are listed in frontend/public/index.html.

// Registration plates. Plain zero, so 0 and 8 never blur at small bold sizes.
export const plateFont = { fontFamily: "'Azeret Mono', monospace" };

// Free-form codes mixing letters and digits (part, manufacturer, catalogue, job codes).
// Dotted zero keeps 0 and O apart.
export const codeFont = { fontFamily: "'JetBrains Mono', monospace" };

// Everything else numeric: work/invoice/order numbers, times, timers, sums, quantities.
export const numFont = { fontFamily: "'Plus Jakarta Sans', sans-serif", fontVariantNumeric: 'tabular-nums' };
